import { render, staticRenderFns } from "./ExercisePage.vue?vue&type=template&id=10f9a9ee&scoped=true"
import script from "./ExercisePage.vue?vue&type=script&lang=js"
export * from "./ExercisePage.vue?vue&type=script&lang=js"
import style0 from "./ExercisePage.vue?vue&type=style&index=0&id=10f9a9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9a9ee",
  null
  
)

export default component.exports